import styled from 'styled-components';
import tw from 'twin.macro';

// ─── Banner ──────────────────────────────────────────────────────────────────

export const BannerContainer = styled.div`
  ${tw`fixed z-50 bg-white`}
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 680px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
`;

export const BannerContent = styled.div`
  ${tw`px-6 py-5`}
`;

export const BannerTitle = styled.p`
  ${tw`font-bold text-gray-900 mb-2`}
  font-size: 1rem;
`;

export const BannerText = styled.p`
  ${tw`text-gray-700 mb-4`}
  font-size: 0.9rem;
  line-height: 1.6;
`;

export const BannerLink = styled.a`
  color: #12CAAE;
  font-weight: 500;
  cursor: pointer;
  &:hover { text-decoration: underline; }
`;

export const BannerActions = styled.div`
  ${tw`flex flex-col sm:flex-row gap-3 justify-end`}
`;

// ─── Buttons ─────────────────────────────────────────────────────────────────

export const OutlineButton = styled.button`
  padding: 10px 24px;
  border-radius: 9999px;
  border: 2px solid #12CAAE;
  color: #12CAAE;
  background: transparent;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;
  &:hover { background: #12CAAE; color: white; }
`;

export const PrimaryButton = styled.button`
  padding: 10px 24px;
  border-radius: 9999px;
  background: #12CAAE;
  color: white;
  font-weight: 600;
  font-size: 0.875rem;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
  &:hover { opacity: 0.85; }
`;

// ─── Modal ────────────────────────────────────────────────────────────────────

export const ModalHeader = styled.div`
  ${tw`flex justify-between items-start mb-4`}
`;

export const ModalTitle = styled.h2`
  ${tw`font-bold text-gray-900`}
  font-size: 1.25rem;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #718096;
  cursor: pointer;
  line-height: 1;
  padding: 0 4px;
  &:hover { color: #1a202c; }
`;

export const ModalText = styled.p`
  ${tw`text-gray-700`}
  font-size: 0.875rem;
  line-height: 1.6;
  margin-bottom: 4px;
`;

export const ModalLink = styled.a`
  color: #12CAAE;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  &:hover { text-decoration: underline; }
`;

export const ModalFooter = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 16px;
  margin-top: 8px;
  border-top: 1px solid #e2e8f0;
  flex-shrink: 0;
`;

// ─── Accordion ────────────────────────────────────────────────────────────────

export const AccordionSection = styled.div`
  border-bottom: 1px solid #e2e8f0;
  padding: 16px 0;
`;

export const AccordionHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  text-align: left;
`;

export const AccordionLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const AccordionTitle = styled.span`
  font-weight: 700;
  color: #1a202c;
  font-size: 0.9375rem;
`;

export const AlwaysActive = styled.span`
  color: #12CAAE;
  font-weight: 700;
  font-size: 0.875rem;
  white-space: nowrap;
`;

export const AccordionBody = styled.div`
  margin-top: 12px;
  font-size: 0.875rem;
  color: #4a5568;
  line-height: 1.7;
`;

// ─── Modal overlay styles (object, not styled-component) ─────────────────────

export const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    position: 'relative',
    inset: 'auto',
    maxWidth: '640px',
    width: '90%',
    maxHeight: '85vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '12px',
    padding: '0',
    border: 'none',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
};
